import React, { useState } from 'react';
import { Layers, Menu, X, CalendarCheck } from 'lucide-react';

const heading = { fontFamily: "'Outfit', sans-serif" };
export const NAV = [['#features', 'Features'], ['#workflow', 'How it works'], ['#website', 'Website builder'], ['#pricing', 'Pricing'], ['#contact', 'Contact']];

export const PlatformHeader = ({ name, login, signup, signupEnabled = true }) => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="decoworkflow-header" className="sticky top-0 z-40 border-b border-slate-800/80 bg-slate-950/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6 sm:py-4">
        <a href="/" data-testid="decoworkflow-logo" className="flex shrink-0 items-center gap-2.5" style={heading}>
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-indigo-600"><Layers size={16} /></span>
          <span className="text-lg font-extrabold tracking-tight sm:text-xl">{name}</span>
        </a>
        <nav className="hidden items-center gap-7 text-sm text-slate-400 lg:flex">
          {NAV.map(([h, l]) => (
            <a key={h} href={h} data-testid={`nav-${l.toLowerCase().replace(/[^a-z]+/g, '-')}`} className="transition-colors hover:text-slate-100">{l}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <a href={login} data-testid="decoworkflow-staff-login-button" className="hidden rounded-xl border border-slate-700/80 px-4 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-slate-500 lg:inline-flex">Staff login</a>
          {signupEnabled && <a href={signup} data-testid="decoworkflow-nav-signup-button" className="hidden rounded-xl border border-indigo-500/60 px-4 py-2 text-sm font-semibold text-indigo-200 transition-colors hover:border-indigo-400 hover:text-white md:inline-flex">Start free trial</a>}
          <a href="#demo-form" data-testid="decoworkflow-nav-demo-button" className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-3.5 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-600/25 transition-colors hover:bg-indigo-500 sm:px-4">
            <CalendarCheck size={15} /><span className="hidden sm:inline">Schedule a Free Demo</span><span className="sm:hidden">Free Demo</span>
          </a>
          <button type="button" aria-label="Menu" data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} className="grid h-9 w-9 place-items-center rounded-xl border border-slate-700/80 text-slate-200 lg:hidden">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-slate-800/80 bg-slate-950 px-4 py-4 lg:hidden">
          <nav className="grid gap-1">
            {NAV.map(([h, l]) => (
              <a key={h} href={h} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.toLowerCase().replace(/[^a-z]+/g, '-')}`} className="rounded-lg px-3 py-3 text-base font-medium text-slate-200 hover:bg-slate-900">{l}</a>
            ))}
          </nav>
          <div className="mt-3 grid gap-2 border-t border-slate-800/80 pt-3">
            {signupEnabled && <a href={signup} data-testid="mobile-signup-button" className="rounded-xl border border-indigo-500/60 px-4 py-3 text-center text-sm font-semibold text-indigo-200">Start free 14-day trial</a>}
            <a href={login} data-testid="mobile-staff-login-button" className="rounded-xl border border-slate-700/80 px-4 py-3 text-center text-sm font-medium text-slate-300">Staff login</a>
          </div>
        </div>
      )}
    </header>
  );
};
